
import ip from 'icepick';
import { ReducerType } from '../types';
import {
    UPDATE_PRIMARY_VEHICLE,
    UPDATE_SELECTED_DEALER,
    UPDATE_SELECTED_VEHICLE,
    UPDATE_SELECTED_VEHICLE_ADDITIONAL_DATA,
    UPDATE_DEALER_DETAILS
} from './type';
const initialState: ReducerType = ip.freeze({
    selectedDealer: null,
    selectedVehicle: null,
    primaryVehicle: null,
    selectedVehicleAdditionalData: null,
    dealerDetails: null
})
const myCarDealerReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SELECTED_DEALER: {
            state = ip.setIn(state, ['selectedDealer'], action.payload);
            return state;
        }
        case UPDATE_SELECTED_VEHICLE: {
            state = ip.setIn(state, ['selectedVehicle'], action.payload);
            return state;
        }
        case UPDATE_PRIMARY_VEHICLE: {
            state = ip.setIn(state, ['primaryVehicle'], action.payload);
            return state;
        }
        case UPDATE_SELECTED_VEHICLE_ADDITIONAL_DATA: {
            state = ip.setIn(state, ['selectedVehicleAdditionalData'], action.payload);
            return state;
        }
        case UPDATE_DEALER_DETAILS: {
            state = ip.setIn(state, ['dealerDetails'], action.payload);
            return state;
        }
        default:
            return state;
    }
}
export default myCarDealerReducer;